module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_6.1acb28d5.jpg";